import { useState } from "react";
import { NativeSelect } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { BaseData, Optional } from "../../../types/common";
import Popup from "../Popup";
import { InputWrapper, ISystemModal, PopupBody } from "../tables/SettingStaticTable";

const DismountModal = <T extends Optional<BaseData, "id">>({
	inputData,
	settingName,
	tableData,
	modalButtonText,
	setSetting,
}: ISystemModal<T>) => {
	const [modalSelectedType, setModalSelectedType] = useState<string>();

	const handleSubmit = () => {
		if (modalSelectedType !== undefined) setSetting(settingName as keyof T, [...tableData, parseInt(modalSelectedType)] as T[keyof T]);
		else {
			notifications.show({ title: "Info", message: "Please select dismount", color: "blue", autoClose: 5000 });
			return false;
		}

		return true;
	};

	return inputData.dismounts ? (
		<Popup title={""} modalButtonText={modalButtonText} handleSubmit={handleSubmit}>
			<PopupBody>
				<InputWrapper>
					<h4>Dismount</h4>
					<NativeSelect
						required
						w={"70%"}
						placeholder="Select dismount"
						data={[
							{ value: "-1", label: "Select dismount" },
							...inputData.dismounts.map((dismount, i) => ({
								value: i.toString(),
								label: dismount.name,
							})),
						]}
						onChange={(e) => {
							e.target.value !== "-1" && inputData.dismounts
								? setModalSelectedType(inputData.dismounts[e.target.value as unknown as number].id.toString())
								: setModalSelectedType(undefined);
						}}
						defaultChecked={false}
					/>
				</InputWrapper>
			</PopupBody>
		</Popup>
	) : null;
};

export default DismountModal;
